import { render, staticRenderFns } from "./ExchangeRateChart.vue?vue&type=template&id=baceb202&scoped=true"
import script from "./ExchangeRateChart.vue?vue&type=script&lang=js"
export * from "./ExchangeRateChart.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRateChart.vue?vue&type=style&index=0&id=baceb202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baceb202",
  null
  
)

export default component.exports